import React from 'react'

function ProLic() {
  return (
      <div style={{ padding: '50px', fontSize: '10px' }}>
          <h1>
              هي الأنشطة التي تشمل الاستثمارات في مجال التطوير 
              <br />
              العقاري، على ألا تقل تكلفة المشروع عن (30) ثلاثون 
              <br />
              مليون ريال سعودي أرضا وبناء خارجنطاق مدينتي مكة
              <br />
              المكرمة، والمدينة المنورة.
              </h1>
      </div>
  )
}

export default ProLic